<template>
    <div id="game row">
        <div class="col-12" v-if="game.user1_id != logged_in_user && game.user2_id != logged_in_user">
            <a href="/matchrequests" class="btn btn-danger btn-lg btn-block">Zuschauen beenden</a>
        </div>
        <div class="col-12 text-right">
            <a href="#" @click.prevent="toggleAudioVolume()"><i :class="['fas', audioVolumeOn() ? 'fa-volume-up' : 'fa-volume-mute']"></i></a>
        </div>
        <div class="col" v-if="gm.players.length > 0">
            <div class="row">
                <div class="col-12 text-center gameoptions">
                    <span class="badge rounded-pill bg-secondary text-light p-2 m-1" v-for="item in game.options" v-bind:key="item.name">{{item.name}}: {{item.value}}</span>
                </div>
            </div>
            <div class="row">
                <div id='status'>
                    <div id='status-progress' style='display: none;' oncontextmenu='event.preventDefault();'><div id ='status-progress-inner'></div></div>
                    <div id='status-indeterminate' style='display: none;' oncontextmenu='event.preventDefault();'>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <div id='status-notice' class='godot' style='display: none;'></div>
                </div>
                <canvas id="canvas"></canvas>
            </div>
        </div>
        <div class="col-12 mt-2">
            <b-tabs fill>
                <b-tab title="Input" v-if="game.user1_id == logged_in_user || game.user2_id == logged_in_user">
                    <numpad :disabledInput='disabledInput' @add="add" @clr="clr" @send="send" @check="check" :allowCheck="allowCheckCheck()"></numpad>
                </b-tab>
                <b-tab title="Verlauf">
                    <game-asset-game-history
                        :isSpectator="game.user1_id != logged_in_user && game.user2_id != logged_in_user"
                        :watchstarted="watchstarted"
                        :content="content"
                        :headers = "[
                            {class: 'w-40', name: 'Score', value: 'score_player1'},
                            {class: 'w-20', name: 'Round', value: 'round'},
                            {class: 'w-40', name: 'Score', value: 'score_player2'}
                        ]"
                    />
                </b-tab>
            </b-tabs>
        </div>

        <b-modal id="modal-leg-end" title="Leg Over" @hidden="nextLeg">
            <p class="my-4">Game!</p>
            <p>Gewinner: {{this.winner ? this.winner.name : ""}}</p>
            <game-asset-game-history
                :isSpectator="game.user1_id != logged_in_user && game.user2_id != logged_in_user"
                :watchstarted="watchstarted"
                :content="content"
                :headers = "[
                    {class: 'w-40', name: 'Score', value: 'score_player1'},
                    {class: 'w-20', name: 'Round', value: 'round'},
                    {class: 'w-40', name: 'Score', value: 'score_player2'}
                ]"
            />
            <template #modal-footer>
                <div class="w-100">
                <p class="float-left">Bitte zum n&auml;chsten Leg:</p>
                <game-asset-next-leg @nextleg="nextLeg"></game-asset-next-leg>
                </div>
            </template>
        </b-modal>


        <b-modal id="modal-game-end" title="Match Over" @hidden="backToMatchmaking">
            <p class="my-4">Game! Set! and Match!</p>
            <p>Gewinner: {{this.winner ? this.winner.name : ""}}</p>
            <game-asset-game-history
                :isSpectator="game.user1_id != logged_in_user && game.user2_id != logged_in_user"
                :watchstarted="watchstarted"
                :content="content"
                :headers = "[
                    {class: 'w-40', name: 'Score', value: 'score_player1'},
                    {class: 'w-20', name: 'Round', value: 'round'},
                    {class: 'w-40', name: 'Score', value: 'score_player2'}
                ]"
            />
            <template #modal-footer>
                <div class="w-100">
                <p class="float-left">Das Match ist beendet.</p>
                <b-button
                    variant="danger"
                    size="sm"
                    class="float-right"
                    @click="backToMatchmaking"
                >
                    Zur&uuml;ck zum Matchmaking
                </b-button>
                </div>
            </template>
        </b-modal>
        <game-asset-determine-start-player :startDetermineStartPlayer="startingPlayerDetermined" :firstleg="gm.firstleg" :game="game" @activePlayer="setStartingPlayer" :gameState="gm.gameState"></game-asset-determine-start-player>
        <game-asset-video-player :throwPoints="gm.lastscore"></game-asset-video-player>
        <game-asset-game-results :game="game"></game-asset-game-results>
        <game-engine></game-engine>
    </div>
</template>

<script>

    import numpad from './gameAssets/gameAssetNumpad.vue';
    import GameAssetScorePlayer from './gameAssets/gameAssetScorePlayer.vue';
    import GameAssetGameHistory from './gameAssets/gameAssetGameHistory.vue';
    import GameAssetDetermineStartPlayer from './gameAssets/gameAssetDetermineStartPlayer.vue';
    import GameAssetVideoPlayer from './gameAssets/gameAssetVideoPlayer.vue';
    import AudioPlayer from './gameAssets/gameAssetAudioPlayer.js';
    import GameAssetStatistics from './gameAssets/gameAssetStatisticsSmall.vue';
    import GameAssetGameResults from './gameAssets/gameAssetGameResults.vue';

    import GameManger from './gameAssets/gameManager';

    import * as start from '../../../games/Playground/DartsTestStart';

    export default {
        components: {
            numpad,
            GameAssetScorePlayer,
            GameAssetGameHistory,
            GameAssetDetermineStartPlayer,
            GameAssetVideoPlayer,
            GameAssetStatistics,
            GameAssetGameResults,
            GameEngine: () => {
                return new Promise((resolve, reject) => {
                    let script = document.createElement('script')
                    script.onload = () => {
                        start.startGodot()
                        resolve()
                    }
                    script.async = true
                    script.src = '/js/gameengine.js'
                document.head.appendChild(script)
                })
            }
        },
        props: ['game_prop', 'player1_prop', 'player2_prop', 'logged_in_user', 'logged_in_player', 'cpu'],
        mixins: [AudioPlayer],
        data() {
            return {
                throw: 0,
                throwPoints: 0,
                game: this.game_prop,
                player1: this.player1_prop,
                player2: this.player2_prop,
                content: {},
                winner: null,
                disabledInput: true,
                watchstarted: false,
                startingPlayerDetermined: false,
                outOption: "Double Out",

                players: []
            }
        },
        created() {

            //create game manager object and read options
            this.gm = new GameManger(this);
            this.gm.start();
        },
        mounted() {
            if (this.game.status == "completed") {
                //do not parse the game when it is completed
                //the game show results component will do this
                return;
            }
        },
        methods: {
            createPlayers() {
                return new Promise((resolve, reject) => {
                    //create the players used in this game
                    //TODO: do not use player1_prop, use relationship table game has many players through.
                    if (this.cpu) {
                        this.gm.createPlayerObjects([this.player1_prop]);
                        this.gm.createCPUPlayerObject();
                    } else {
                        this.gm.createPlayerObjects([this.player1_prop, this.player2_prop]);
                    }
                    resolve();
                })
            },
            createUIElements() {
                return new Promise((resolve, reject) => {
                    resolve();
                })
            },
            setPlayerOptions() {
                return new Promise((resolve, reject) => {
                    this.gm.players.forEach(player => {
                        player.start = this.gm.gameoptions.Start;
                        player.score = parseInt(player.start)
                        player.throw = 0;
                        player.singlescores = [];
                    });
                    this.outOption = this.gm.gameoptions.Out;
                    this.clr();
                    resolve();
                });
            },
            setStartingPlayer(id) {
                console.log("setting startting player to: " + id)
                this.startDetermineStartPlayer = false;
                this.gm.setActivePlayer(id, true);
                this.gm.setNextState();
            },

            prepareActivePlayer() {
                return new Promise((resolve, reject) => {
                    this.gm.getActivePlayer().throw = 0;
                    this.gm.getActivePlayer().singlescores = [];
                    this.clr();
                    setTimeout(e => {
                        this.throwPoints = -1; //reset throw points for videoplayer
                    })
                    resolve();
                })
            },
            winCheck() {
                return new Promise((resolve, reject) => {
                    var winner = false;
                    this.gm.players.forEach(player => {
                        if (player.score == 0) {
                            winner = true;
                        }
                    });
                    resolve({winner: winner});
                })
            },
            winCheckSingle() {
                return new Promise((resolve, reject) => {
                    var player = this.gm.getActivePlayer();
                    var score = player.score;
                    var multiplier = player.singlescores[player.singlescores.length - 1].multiplier;
                    var result = score - this.throw;
                    var winner = false;
                    //check < 0 first
                    if (result <0) this.singleScoreBust();
                    //single out check
                    if (this.outOption == "Single Out" && result == 0) {
                        this.send();
                        winner = true;
                    }
                    //double out check
                    if (this.outOption == "Double Out" && result == 0 && multiplier == 2) {
                        this.send();
                        winner = true;
                    } else if (this.outOption == "Double Out" && ((result == 0 && multiplier != 2) || (result == 1))) {
                        this.singleScoreBust();
                    }
                    //master out check
                    if (this.outOption == "Master Out" && ((result == 0 && multiplier != 1) || (result == 1))) {
                        this.send();
                        winner = true;
                    } else if (this.outOption == "Master Out" && result == 0 && multiplier == 2) {
                        this.singleScoreBust();
                    }
                    resolve({winner: winner});
                })
            },
            singleScoreBust() {
                toastError("Ueberworfen");
                this.throw = 0;
                //mark the last dart as missed
                this.gm.getActivePlayer().singlescores[this.gm.getActivePlayer().singlescores.length-1].missed = true;
                this.send();
            },

            add(number) {
                if (this.throw + number > 180) return; //dont allow to add more than 180 to your throw
                if (this.gm.getActivePlayer().throw == 0) this.gm.getActivePlayer().throw = "";
                this.gm.getActivePlayer().throw += number;
                this.throw = this.gm.getActivePlayer().throw;
            },
            clr() {
                this.gm.getActivePlayer().throw = 0;
                this.gm.getActivePlayer().singlescores = [];
                this.throw = 0;
            },
            check(number) {
                this.throw = this.gm.getActivePlayer().score;
                if (number == 0) {
                    this.throw = 0;
                }
                this.send();
            },
            send() {
                if (this.checkValidThrow()) {
                    axios.post("/api/games/" + this.game.id + "/sendfullscore", {player: this.gm.getActivePlayer().id, score: this.throw, singlescores: this.gm.getActivePlayer().singlescores}).then(() => {
                        console.log("Waiting for Input complete")
                        this.throwPoints = this.throw;
                        this.gm.setNextState();
                    })
                } else {
                    console.log("Error: Non Valid throw");
                }
            },
            checkValidThrow() {
                //dont allow return above 180
                //console.log(this.active_player + " wants to send a score: " + this.throw);
                if (this.throw > 180) {
                    toastError("Fehlerhafter Wert, kann nicht größer als 180 sein");
                    return false;
                }
                if (this.gm.getActivePlayer().score - this.throw < 0) {
                    toastError("Fehlerhafter Wert, Ergebnis wäre kleiner 0");
                    return false;
                }
                if (this.logged_in_user != this.gm.getActivePlayer().user_id) {
                    return false;
                }
                return true;
            },
            parseContent() {
                //parses the content of the leg to show what happens in this game
                if (!this.content || !this.content.start) return;
                var last_active_player_id = 0;
                var last_score = 0;
                this.gm.players.forEach(player => {
                    player.score = this.content.start;
                });
                this.content.throws.forEach(t => {
                    this.gm.players.forEach(player => {
                        if (t.player == player.id) {
                            player.score -= parseInt(t.fullscore);
                            player.throw = t.fullscore;
                            last_active_player_id = player.id;
                            last_score = player.throw;
                        }
                    });
                });
                return {lastplayer:last_active_player_id, lastscore:last_score};
            },
            showWinner() {
                this.gm.players.forEach(player => {
                    if (player.score == 0) {
                        this.winner = player;
                    }
                });
                if (this.winner != null)
                    this.$bvModal.show('modal-game-end');
            },
            backToMatchmaking() {
                window.location.href = "/matchrequests/";
            },
            showResults() {
                axios.post("/games/" + this.game.id + "/results").then((response) => {
                    this.content = response.data;
                    this.parseContent();
                    this.$bvModal.show('modal-game-end');
                })
            },
            parseSingleScore(activeplayer, dart) {
                //mark as missed if dart value is 0
                if (dart.value == 0) dart.missed = true;
                if (activeplayer.singlescores.length < 3) {
                    this.throw = 0;
                    activeplayer.singlescores.push(dart);
                    activeplayer.singlescores.forEach(score => {
                        this.throw += score.value;
                    });
                }
                window.webinterface = JSON.stringify({'player': "1", 'dart': dart.str, 'action': 'throw'})
                if (dart.base == 15 && dart.multiplier == 2) this.playAudioFile("DoppelBull");
                if (dart.base == 20 && dart.multiplier == 3) this.playAudioTripple(20);
                if (dart.base == 19 && dart.multiplier == 3) this.playAudioTripple(19);
                if (dart.base == 18 && dart.multiplier == 3) this.playAudioTripple(18);
                if (dart.base == 17 && dart.multiplier == 3) this.playAudioTripple(17);
            },
            showNextLeg() {
                this.$bvModal.show('modal-leg-end');
            },
            nextLeg() {
                toastSuccess("Starte naechstes Leg");
                this.gm.startNextLeg()
                this.$bvModal.hide('modal-leg-end');
                //location.reload();
            },
            allowCheckCheck() {
                if (!this.gm.getActivePlayer()) return false;
                var returnValue = false;
                if (this.gm.getActivePlayer().score <= 180) return true;
                return returnValue;
            },
            calculatedScore(player_id) {
                if (this.gm.getActivePlayer().id == player_id && this.gm.getActivePlayer().score != 0) {
                    return this.gm.getActivePlayer().score - this.throw;
                }
            }
        }
    }
</script>

<style scoped>
    .gameoptions {
        margin-bottom: -2.6em;
        margin-top: 0.3em;
    }
</style>
